// Splide init
function mmInitSplide() {
	const id = '.splide-mm-cart';
	const splideElem = document.querySelector(id);
	const idrea = '.splide-cta-testimonials';
	const splideElemrea = document.querySelector(idrea);

	if (splideElem) {
		new Splide(splideElem, {
			type: 'splide',
			arrows: true,
			pagination: false,
			rewind: false,
			gap: 20,
			perPage: 2,
			direction: 'ttb',
			height: '100%',
			destroy: true,
			breakpoints: {
				701: {
					destroy: false,
					rewind: true,
					direction: 'ltr',
					perPage: 1,
					padding: {
						left: '30px',
						right: '60px',
					},
				},
			},
		}).mount();
	}

	if (splideElemrea) {
		new Splide(splideElemrea, {
			type: 'loop',
			arrows: true,
			pagination: false,
			gap: 0,
			perPage: 1,
			autoplay: true,
			interval: 3000,
		}).mount();
	}
}

document.addEventListener(
	'DOMContentLoaded',
	() => {
		mmInitSplide();
	},
	{ once: true }
);

function mmToggleFreeProductsList(classElem) {
	document.querySelector(classElem).classList.toggle('mm-open');
}

// Debounce
// https://redd.one/blog/debounce-vs-throttle
// If function is called several times in {duration},
// wait for a pause longer than {duration} to actually trigger it.
// eg, wait 500 milliseconds after last call to actually call doSomething():
// debounce(function () {
//    doSomething();
//  }, 500)
function debounce(func, duration) {
	let timeout;
	return function (...args) {
		const effect = () => {
			timeout = null;
			return func.apply(this, args);
		};
		clearTimeout(timeout);
		timeout = setTimeout(effect, duration);
	};
}

function mmCartSectionElement() {
	return document.getElementById('shopify-section-mm-cart');
}

function mmCartProductsContainerElement() {
	return mmCartSectionElement().querySelector('.mm-dc-products-container');
}

function mmCartItem(productVariantId) {
	return mmCartProductsContainerElement().querySelector(`[data-cart-item-id="${productVariantId}"]`);
}

function mmCartItemQuantityEl(productVariantId) {
	const itemEl = mmCartItem(productVariantId);

	return itemEl.querySelector('[data-item-quantity]');
}

function mmGetCartItemQuantity(productVariantId) {
	const quantityEl = mmCartItemQuantityEl(productVariantId);

	return Number.parseInt(quantityEl.dataset.itemQuantity);
}

function mmSetCartItemQuantity(productVariantId, newQuantity) {
	// Display qtty in front
	if (newQuantity >= 0) {
		const quantityEl = mmCartItemQuantityEl(productVariantId);

		quantityEl.dataset.itemQuantity = newQuantity;
		quantityEl.innerText = newQuantity;
	}
}

function mmCartHTMLFromData(data) {
	const el = document.createElement('DIV');
	el.innerHTML = data.sections['mm-cart'];

	return el;
}

function extractItemsFromCartHTML(data) {
	const el = mmCartHTMLFromData(data);
	return el.querySelector('.mm-dc-products-container');
}

function insertCartProductsFromResponse(data) {
	const itemsContainer = extractItemsFromCartHTML(data);
	mmCartProductsContainerElement().innerHTML = itemsContainer.innerHTML;

	return data;
}

function extractTotalPriceFromCartHTML(data) {
	const cartEl = mmCartHTMLFromData(data); // ¡ fait atención gringo !
	return cartEl.querySelector('[data-cart-total-price]');
}

function insertInsertTotalPriceFromResponse(data) {
	const newTotalPriceEl = extractTotalPriceFromCartHTML(data);
	const currentTotalPriceEl = mmCartSectionElement().querySelector('[data-cart-total-price]');
	currentTotalPriceEl.innerHTML = newTotalPriceEl.innerHTML;

	return data;
}

function mmAPIRequest(method, path, body) {
	document.querySelector('.mm-dc-products')?.classList?.add('mm-inactive');
	return fetch(window.Shopify.routes.root + path, {
		method: method,
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify(body),
	})
		.then((response) => response.json())
		.then((data) => {
			// mmLog(data);
			document.querySelector('.mm-dc-products')?.classList?.remove('mm-inactive');
			if (data.status && data.status > 400) {
				throw data;
			} else {
				return data;
			}
		});
}

// récupérer le panier
function mmGetCart() {
	return mmAPIRequest('GET', 'cart.js');
}

// Ouvrir le panier
function mmOpenCart() {
	mmGetCart();
	document.querySelector('.mm-drawer-cart-filter').classList.add('mm-dc-is-open');
	if (document.querySelector('.mobileMenu').classList.contains('mm-menu-open')) {
		document.querySelector('.mobileMenu').classList.remove('mm-menu-open');
	}
	if (document.querySelector('.sidebarBgg').classList.contains('mm-menu-open')) {
		document.querySelector('.sidebarBgg').classList.remove('mm-menu-open');
	}
	if (document.querySelector('.sidebarMenu').classList.contains('mm-menu-open')) {
		document.querySelector('.sidebarMenu').classList.remove('mm-menu-open');
	}
	if (document.getElementById('mmSearchMobileWrapper').classList.contains('mm-active')) {
		document.getElementById('mmSearchMobileWrapper').classList.remove('mm-active');
	}
	document.querySelector('html').classList.add('stop-scrolling');
}

// Ouvrir et refresh le panier (utilisé pour faire fonctionner les babybox et superbox avec le panier)
function mmOpenAndRefreshCart() {
	function handleResponse() {
		const newCartEl = document.createElement('DIV');
		newCartEl.innerHTML = this.responseText;
		const innerCart = mmCartSectionElement().querySelector('.mm-drawer-cart-filter');
		innerCart.innerHTML = newCartEl.querySelector('.mm-drawer-cart-filter').innerHTML;
		mmInitSplide();
		document.querySelector('.mm-drawer-cart-filter').classList.add('mm-dc-is-open');
		document.querySelector('html').classList.add('stop-scrolling');
	}
	const request = new XMLHttpRequest();
	request.addEventListener('load', handleResponse);
	request.open('GET', '/?section_id=mm-cart', true);
	request.send();
}

// Fermer le panier
function mmCloseCart() {
	document.querySelector('.mm-drawer-cart-filter').classList.remove('mm-dc-is-open');
	document.querySelector('html').classList.remove('stop-scrolling');
}

// Re-render cart inner HTML from response
function refreshCartFromData(data) {
	const newCartEl = document.createElement('DIV');
	newCartEl.innerHTML = data.sections['mm-cart'];
	const innerCart = mmCartSectionElement().querySelector('.mm-drawer-cart-filter');
	innerCart.innerHTML = newCartEl.querySelector('.mm-drawer-cart-filter').innerHTML;

	var reviews = innerCart.querySelectorAll('.jdgm-prev-badge__text');
	reviews.forEach(function (review) {
		var newText = review.innerHTML.replace('reviews', 'avis');
		review.innerHTML = newText;
	});

    if (data['item_count'] == 0) {
        localStorage.removeItem('free_product_choice_1');
        localStorage.removeItem('free_product_choice_2');		
	}
		
	const countdownElement = document.querySelector('.mm-dc-countdown');
    if (countdownElement) {
        if (data['item_count'] == 0) {
			localStorage.removeItem('countdownTime');
            if (SimpleCountdown.instance) {
                SimpleCountdown.instance.reset();
            }
        } else {
			if (!SimpleCountdown.instance) {
                const countdown = new SimpleCountdown(
                    parseInt(countdownElement.dataset.duration),
                    countdownElement.id
                );
                countdown.start();
            }
        }
    }
	mmInitSplide();

	// Mettre à jour le compteur du panier
	mmUpdateCartCounter();

	// Déclencher un événement personnalisé pour indiquer que le panier a été mis à jour
	window.dispatchEvent(new CustomEvent('cartUpdated', { detail: data }));

	return data;
}

class SimpleCountdown {
    static instance = null;
    
    constructor(duration, elementId) {
        if (SimpleCountdown.instance) {
            SimpleCountdown.instance.element = document.getElementById(elementId);
            return SimpleCountdown.instance;
        }
        
        this.duration = duration;
        this.elementId = elementId;
        this.element = document.getElementById(elementId);
        this.interval = null;
        this.currentTime = duration;
        SimpleCountdown.instance = this;
    }

    start() {
        const storedTime = localStorage.getItem('countdownTime');
        const storedStartTime = localStorage.getItem('countdownStartTime');

        if (storedTime && storedStartTime) {
            const elapsedTime = Math.floor((Date.now() - parseInt(storedStartTime)) / 1000);
            this.currentTime = Math.max(parseInt(storedTime) - elapsedTime, 0);
            
            if (this.currentTime <= 0) {
                this.currentTime = this.duration;
                localStorage.setItem('countdownStartTime', Date.now().toString());
            }
        } else {
            this.currentTime = this.duration;
            localStorage.setItem('countdownStartTime', Date.now().toString());
        }

        localStorage.setItem('countdownTime', this.currentTime.toString());

        if (this.interval) {
            clearInterval(this.interval);
        }
        this.update();
        this.interval = setInterval(() => this.update(), 1000);
    }

    reset() {
        if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
        }
        localStorage.removeItem('countdownTime');
        localStorage.removeItem('countdownStartTime');
        this.currentTime = this.duration;
        if (this.element) {
            this.element.innerHTML = '';
        }
        SimpleCountdown.instance = null;
    }

    update() {
        this.element = document.getElementById(this.elementId);
		if (!this.element) return;

		this.currentTime--;
		
		if (this.currentTime < 0) {
			this.currentTime = this.duration;
			localStorage.setItem('countdownStartTime', Date.now().toString());
		}

		localStorage.setItem('countdownTime', this.currentTime.toString());

		const minutes = Math.floor(this.currentTime / 60);
		const seconds = this.currentTime % 60;

		// Formatage avec padding de zéros
		const displayMinutes = String(minutes).padStart(2, '0');
		const displaySeconds = String(seconds).padStart(2, '0');
		
		this.element.innerHTML = `${displayMinutes}:${displaySeconds}min`;
    }
}

// Initialisation au chargement de la page
document.addEventListener('DOMContentLoaded', function() {
    const countdownElement = document.querySelector('.mm-dc-countdown');
    const storedTime = localStorage.getItem('countdownTime');
    const storedStartTime = localStorage.getItem('countdownStartTime');
    const cartItemCount = document.querySelector('[data-cart-count]')?.textContent;

    // Si on a un compteur et des données stockées
    if (countdownElement && storedTime && storedStartTime) {
        const countdown = new SimpleCountdown(
            parseInt(countdownElement.dataset.duration),
            countdownElement.id
        );
        
        const elapsedTime = Math.floor((Date.now() - parseInt(storedStartTime)) / 1000);
        countdown.currentTime = Math.max(parseInt(storedTime) - elapsedTime, 0);
        
        if (countdown.currentTime === 0) {
            countdown.currentTime = countdown.duration;
            localStorage.setItem('countdownStartTime', Date.now().toString());
        }
        
        countdown.start();
    } 
    // Si on a un compteur mais pas de données stockées
    else if (countdownElement && cartItemCount && parseInt(cartItemCount) > 0) {
        const countdown = new SimpleCountdown(
            parseInt(countdownElement.dataset.duration),
            countdownElement.id
        );
        countdown.start();
    }
});

// Ajouter un item au panier
function mmAddProductToCart(productId, { quantity = 1, openCart = true }) {
	if (document.querySelector('.product-form__variants')) {
		productId = document.querySelector('.product-form__variants').value;
	}
	if (document.querySelector('.rc-selling-plans__dropdown')) {
		var sellingPlanId = document.querySelector('.rc-selling-plans__dropdown').value;
		mmAddProductRcToCart(productId, { quantity: 1, openCart: true, SellingPlanId: sellingPlanId });
	} else {
		mmAPIRequest('POST', 'cart/add.js', {
			items: [{ quantity: quantity, id: productId }],
			sections: 'mm-cart',
		})
			.then(mmAddOrRemoveFreeProducts)
			.then(refreshCartFromData)
			.then((data) => {
				if (openCart) {
					setTimeout(mmOpenCart);
				}
			})
			.catch((error) => {
				mmCartProductsContainerElement().innerHTML = `
        Oups, il y a eu une erreur, essayez de recharger la page !
        `;
				mmOpenCart();
				console.log(error);
			});
	}
}

//QuickBuy
function mmAddProductToCartQB(productId, { quantity = 1, openCart = true }) {
	mmAPIRequest('POST', 'cart/add.js', {
		items: [{ quantity: quantity, id: productId }],
		sections: 'mm-cart',
	})
		.then(mmAddOrRemoveFreeProducts)
		.then(refreshCartFromData)
		.then((data) => {
			if (openCart) {
				setTimeout(mmOpenCart);
			}
		})
		.catch((error) => {
			mmCartProductsContainerElement().innerHTML = `
				Oups, il y a eu une erreur, essayez de recharger la page !
			`;
			mmOpenCart();
			console.log(error);
		});
}

// Ajouter un item d'abonnement au panier
function mmAddProductRcToCart(productId, { quantity = 1, openCart = true, SellingPlanId }) {
	mmAPIRequest('POST', 'cart/add.js', {
		items: [{ quantity: quantity, id: productId, selling_plan: SellingPlanId }],
		sections: 'mm-cart',
	})
		.then(mmAddOrRemoveFreeProducts)
		.then(refreshCartFromData)
		.then((data) => {
			if (openCart) {
				setTimeout(mmOpenCart);
			}
		})
		.catch((error) => {
			mmCartProductsContainerElement().innerHTML = `
				Oups, il y a eu une erreur, essayez de recharger la page !
			`;
			mmOpenCart();
			console.log(error);
		});
}

function mmIncreaseProductQuantity(productVariantId) {
	const quantity = mmGetCartItemQuantity(productVariantId);
	const newQuantity = quantity + 1;
	mmSetCartItemQuantity(productVariantId, newQuantity);

	mmDebouncedPushNewQuantity(productVariantId);
}

function mmDecreaseProductQuantity(productVariantId) {
	const quantity = mmGetCartItemQuantity(productVariantId);
	const newQuantity = quantity - 1;
	mmSetCartItemQuantity(productVariantId, newQuantity);

	mmDebouncedPushNewQuantity(productVariantId);
}

function mmDestroyProductFromCart(productVariantId) {
	const newQuantity = 0;
	mmSetCartItemQuantity(productVariantId, newQuantity);

	mmDebouncedPushNewQuantity(productVariantId);
}

function mmPushNewQuantity(productVariantId) {
	const quantity = mmGetCartItemQuantity(productVariantId);

	mmAPIRequest('POST', 'cart/change.js', {
		id: productVariantId.toString(),
		quantity: quantity,
		sections: 'mm-cart',
	})
		.then(mmAddOrRemoveFreeProducts)
		.then(refreshCartFromData);
}

let mmDebouncedPushNewQuantity = debounce(function (productVariantId) {
	mmPushNewQuantity(productVariantId);
}, 300);

window.addEventListener('DOMContentLoaded', (event) => {
	mmGetCart();
});

async function mmUpdateCartCounter(data) {
	const cart = await mmGetCart();

	const { item_count: itemCount, items } = cart;
	let superboxItemCount = 0;
	// console.log('items:', items);
	items.forEach((item) => {
		if (item.properties) {
			item.properties.__superpack && (superboxItemCount += item.quantity);
		}
	});

	let newCount = itemCount;
	const cartCounterBadges = document.querySelectorAll('.mm-icon-cart-container .js-go-cart-counter');
	if (superboxItemCount > 0) {
		newCount = newCount - superboxItemCount;
		newCount += 1; // that still only counts as one!
	}
	cartCounterBadges.forEach(function (cartCounterBadge) {
		cartCounterBadge.innerText = newCount;
	});
	if (document.getElementById('mmDisableCta')) {
		if (document.getElementById('mmDisableCta').value == 'true') {
			if (document.querySelector('.product-form .mm-btn-primary-orange')) {
				document.querySelector('.product-form .mm-btn-primary-orange').classList.add('mm-disabled');
			}
		} else {
			if (document.querySelector('.product-form .mm-btn-primary-orange')) {
				document.querySelector('.product-form .mm-btn-primary-orange').classList.remove('mm-disabled');
			}
		}
	}

	return data; // to work in response then chain
}

window.addEventListener('DOMContentLoaded', async (event) => {
	mmUpdateCartCounter();
});

// CHANGE ACTIVE VARIANT
function mmChangeActiveOption(newValue, id) {
	var trueSelect = document.getElementById(id);
	var options = Array.from(trueSelect.options);

	options.forEach(function (option, i) {
		if (option.text == newValue) {
			trueSelect.options.selectedIndex = i;
		}
	});
}

// FREE PRODUCTS
function mmDestroyFreeProductForEver(freeProductId) {
	var freeProductName = 'free_product_cancelled_' + freeProductId;
	localStorage.setItem(freeProductName, 'true');
}

function mmAddOrRemoveFreeProducts(data) {
    if (data.sections['mm-cart']) {
        const el = mmCartHTMLFromData(data);
        const freeProductEls = el.querySelector('[data-free-products]');
        
        if (!freeProductEls) return data;
        
        // Group products by index (1 or 2)
        const productsByIndex = Array.from(freeProductEls.children).reduce((groups, el) => {
            const index = el.dataset.index;
            if (!groups[index]) groups[index] = [];
            groups[index].push({
                id: el.dataset.variantId,
                available: el.dataset.available === 'true',
                isFree: el.dataset.freeProduct === 'true'
            });
            return groups;
        }, {});

        // Find first available product for each index
        for (const index of ['1', '2']) {
            if (productsByIndex[index]) {
                const availableProduct = productsByIndex[index].find(p => p.available);
                if (availableProduct && !localStorage.getItem(`free_product_choice_${index}`)) {
                    localStorage.setItem(`free_product_choice_${index}`, availableProduct.id);
                }
            }
        }

        let freeProductCounts = 0;
        const productsParams = Array.from(freeProductEls.children).reduce((param, freeProductEl) => {
            const productId = freeProductEl.dataset.variantId;
            const isFree = freeProductEl.dataset.freeProduct === 'true';
            const isAvailable = freeProductEl.dataset.available === 'true';
            const itemEl = mmCartItem(productId);
            const freeProductName = 'free_product_cancelled_' + productId;

            if (!isAvailable) return param;

            // Rest of your existing logic
            if (freeProductEl.dataset.freeProductAmount * 100 > el.querySelector('.mm-drawer-cart').dataset.cartTotal) {
                localStorage.setItem(freeProductName, 'false');
            }

            if (isFree) freeProductCounts += 1;

            if (itemEl && isFree) {
                return param;
            } else if (itemEl && !isFree) {
                param[productId] = 0;
            } else if (!itemEl && isFree) {
                if (!localStorage.getItem(freeProductName)) {
                    localStorage.setItem(freeProductName, 'false');
                }
                
                const isSelected = localStorage.getItem(freeProductName) === 'false' && 
                    (localStorage.getItem('free_product_choice_1') === productId || 
                     localStorage.getItem('free_product_choice_2') === productId);
                
                if (isSelected) {
                    param[productId] = 1;
                }
            }
            return param;
        }, {});

        if (Object.keys(productsParams).length > 0) {
            mmAPIRequest('POST', 'cart/update.js', { 
                updates: productsParams, 
                sections: 'mm-cart' 
            }).then(refreshCartFromData);
        }
    }
    return data;
}

function mmAddFreeProductToCart(productId, { quantity = 1, openCart = true }, clickedElem, index) {
	// Debounce sur le CTA
	clickedElem.innerText = 'AJOUTÉ !';
	clickedElem.classList.add('mm-disabled');

	// Add choice in LocalStorage
	var name = 'free_product_choice_' + index;
	localStorage.setItem(name, productId);

	// Ajouter le free product
	mmAddProductToCart(productId, { openCart: false });
}

function mmChangeFreeProductInCart(productVariantIdToAdd, productIndexToRemove, clickedElem, index) {
	// Debounce sur le CTA
	clickedElem.innerText = 'AJOUTÉ !';
	clickedElem.classList.add('mm-disabled');

	// Add choice in LocalStorage
	var name = 'free_product_choice_' + index;
	// console.log('name:', name);
	localStorage.setItem(name, productVariantIdToAdd);

	updateAndRefreshCart(productIndexToRemove, productVariantIdToAdd, 1);
}

function mmNoFreeProduct(localStorageKey, classElem) {
	localStorage.setItem(localStorageKey, 'true');
	mmDestroyProductFromCart(parseInt(document.querySelector(classElem).dataset.cartItemId));
}

async function updateCart(variantIndexToRemove, variantIdToAdd, quantityToAdd) {
	try {
		const lineToRemove = variantIndexToRemove;

		if (!lineToRemove) {
			console.error("L'ID de variante à supprimer n'a pas été trouvé dans le panier");
			return;
		}

		// Étape 1: Supprimer le produit
		const removeResponse = await fetch('/cart/change.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
			body: `line=${lineToRemove}&quantity=0`,
		});

		if (!removeResponse.ok) {
			console.error('Erreur lors de la suppression du produit');
			return;
		}

		// Étape 2: Ajouter le nouveau produit
		const addResponse = await fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
			body: `id=${variantIdToAdd}&quantity=${quantityToAdd}`,
		});

		if (!addResponse.ok) {
			console.error("Erreur lors de l'ajout du nouveau produit");
			return;
		}

		console.log('Nouveau produit ajouté avec succès!');
	} catch (error) {
		console.error('Erreur lors de la mise à jour du panier', error);
	}
}

async function updateAndRefreshCart(variantIdToRemove, variantIdToAdd, quantityToAdd) {
	await updateCart(variantIdToRemove, variantIdToAdd, quantityToAdd);
	await mmOpenAndRefreshCart();
}

function checkAndSetLocalStorage() {
  // Vérifiez si la clé 'NoFreeProduct1' existe dans le localStorage
  if (localStorage.getItem('NoFreeProduct1') === null) {
    // Si la clé n'existe pas, créez-la avec la valeur 'false'
    localStorage.setItem('NoFreeProduct1', 'false');
  }
  // Vérifiez si la clé 'NoFreeProduct2' existe dans le localStorage
  if (localStorage.getItem('NoFreeProduct2') === null) {
    // Si la clé n'existe pas, créez-la avec la valeur 'false'
    localStorage.setItem('NoFreeProduct2', 'false');
  }

  // Lister les ids des free products 1
  const free_products_ids_elems = document.querySelectorAll('[data-free-products] div[data-index="1"]');
  //console.log('free_products_ids_elems', free_products_ids_elems)
  let free_products_ids = [];

  free_products_ids_elems.forEach(function(elem) {
    free_products_ids.push(String(elem.dataset.variantId));
  })
  
  let free_product_choice_1 = String(localStorage.getItem('free_product_choice_1'));

  //console.log('free_products_ids', free_products_ids)
  //console.log('free_product_choice_1', free_product_choice_1)
  
  if (!free_products_ids.includes(free_product_choice_1)) {
    //console.log('La valeur n\'est pas dans free_products_ids');
    localStorage.removeItem('free_product_choice_1');
    
  }
  // Lister les ids des free products 2
  const free_products_ids_elems_2 = document.querySelectorAll('[data-free-products] div[data-index="2"]');
  let free_products_ids_2 = [];

  free_products_ids_elems_2.forEach(function(elem) {
    free_products_ids_2.push(String(elem.dataset.variantId));
  })
  
  let free_product_choice_2 = String(localStorage.getItem('free_product_choice_2'));

  //console.log('free_products_ids_2', free_products_ids_2)
  //console.log('free_product_choice_2', free_product_choice_2)

  if (!free_products_ids_2.includes(free_product_choice_2)) {
    //console.log('La valeur n\'est pas dans free_products_ids_2');
    localStorage.removeItem('free_product_choice_2');
  }
}

// Utiliser la fonction pour vérifier et créer la clé si nécessaire
document.addEventListener('DOMContentLoaded', function() {
    checkAndSetLocalStorage();
});

// Également l'exécuter après les mises à jour du panier
window.addEventListener('cartUpdated', function() {
    checkAndSetLocalStorage();
});
